import { createFocusTrap } from "focus-trap";
import { add, listen, qs, remove } from "@fluorescent/dom";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";

import { events as globalEvents } from "@/constants";
import { hydrate, on } from "@/glow/events";
import { formatMoney } from "@/glow";
import { getSizedImageUrl, imageSize } from "@/lib/images";

const classes = {
  visible: "is-visible",
};

const selectors = {
  closeBtn: "[data-store-availability-close]",
  productTitle: "[data-store-availability-product-title]",
  variantTitle: "[data-store-availability-variant-title]",
  productCard: "[data-store-availability-product]",
  storeListcontainer: "[data-store-list-container]",
  overlay: "[data-overlay]",
};

export default function storeAvailabilityDrawer(node) {
  var focusTrap = createFocusTrap(node, { allowOutsideClick: true });
  const productCard = qs(selectors.productCard, node);
  const storeListContainer = qs(selectors.storeListcontainer, node);

  const events = [
    listen(qs(selectors.closeBtn, node), "click", e => {
      e.preventDefault();
      _close();
    }),
    listen(node, "keydown", ({ keyCode }) => {
      if (keyCode === 27) _close();
    }),
    listen(qs(selectors.overlay, node), "click", () => _close()),
    on(
      globalEvents.availability.toggleDrawer,
      ({ availabilityOpen, product, variant, storeList }) => {
        if (availabilityOpen) {
          productCard.innerHTML = _renderProductCard(product, variant);
          _renderAvailabilityList(storeList);
          _open();
        } else {
          _close();
        }
      }
    ),
  ];

  const _renderAvailabilityList = storeList => {
    storeListContainer.innerHTML = "";
    storeListContainer.appendChild(storeList);
  };

  const _renderProductCard = (
    { featured_image: image, title },
    {
      title: variant_title,
      featured_image,
      price,
      unit_price,
      unit_price_measurement,
    }
  ) => {
    let productImage = _getVariantImage(image, featured_image);

    return `
      <div class="store-availbility-flyout__product-card type-body-regular">
        ${
          productImage
            ? `
            <div class='store-availbility-flyout__product-card-image'>
              <img src='${productImage}' />
            </div>
          `
            : ""
        }
        <div class='store-availbility-flyout__product-card-details'>
          <div>
            <h4 class="ma0">
              <span>${title}</span>
            </h4>
            <div class="store-availbility-flyout__product-price-wrapper type-body-small">
              <span class="store-availbility-flyout__product-price">${formatMoney(
                price
              )}</span>
            </div>
            <div class="store-availbility-flyout__product-card-options type-body-small">
              ${variant_title}
            </div>
          </div>
        </div>
      </div>
    `;
  };

  const _getVariantImage = (productImage, variantImage) => {
    if (!productImage && !variantImage) return "";

    if (variantImage) {
      return _updateImageSize(variantImage.src);
    }

    return _updateImageSize(productImage);
  };

  const _updateImageSize = imageUrl => {
    return getSizedImageUrl(
      imageUrl.replace("." + imageSize(imageUrl), ""),
      "200x"
    );
  };

  const _open = () => {
    add(node, classes.visible);
    focusTrap.activate();
    disableBodyScroll(node, {
      allowTouchMove: el => {
        while (el && el !== document.body) {
          if (el.getAttribute("scroll-lock-ignore") !== null) {
            return true;
          }
          el = el.parentNode;
        }
      },
    });
  };

  const _close = () => {
    remove(node, classes.visible);
    hydrate({ availabilityOpen: false });
    focusTrap.deactivate();
    enableBodyScroll(node);
  };

  const unload = () => {
    events.forEach(unsubscribe => unsubscribe());
  };

  return { unload };
}
